import React from 'react';
import './SkipNavLink.css';

const SkipNavLink = () => (
  <a className="skip-nav-link" href="#main-content">
    Skip to main content
  </a>
);

export default SkipNavLink;
